<template>
  <v-app>
    <v-toolbar clipped-right clipped-left color="white">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" style="color: orange"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-avatar>
          <img :src="userPhoto" v-on="on" />
        </v-avatar>
        <v-btn @click="home" flat color="orange">{{Name}}</v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="files" v-on="on" flat>
              <v-icon dark color="orange">list</v-icon>
            </v-btn>
          </template>
          <span style="color: white">Files</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="score" v-on="on" flat>
              <v-icon dark color="orange">assessment</v-icon>
            </v-btn>
          </template>
          <span style="color: white">Score</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="signout" v-on="on" flat>
              <v-icon dark color="orange">meeting_room</v-icon>
            </v-btn>
          </template>
          <span style="color: white">Sign Out</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      style="color:orange;"
      absolute
      temporary
    >
      <v-list-tile v-if="mini" @click.stop="mini = !mini">
        <v-list-tile-action>
          <v-icon>chevron_right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile avatar tag="div">
        <v-list-tile-avatar>
          <v-avatar v-if="userPhoto">
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>
                  web_asset
                  </v-icon>
                </v-btn>
              </template>
              <v-card hover>
                <v-container grid-list-md>
                  <v-layout row>
                    <v-flex xs12 sm6 md4 reverse>
                      <v-img :src="userPhoto"></v-img>
                    </v-flex>
                    <v-layout column justify-center align-center>
                      <h1>
                        <v-icon>arrow_drop_down</v-icon>Photo URL
                        <v-icon>arrow_drop_down</v-icon>
                      </h1>
                      <h3>{{userPhoto}}</h3>
                      <h5>[ Size : 200x300 px ]</h5>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
            </v-dialog>
          </v-avatar>
          <v-avatar v-else>
            <v-icon>person</v-icon>
          </v-avatar>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-text-field v-model="Name" :value="Name" @change="chgname" color="orange"></v-text-field>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click.stop="mini = !mini">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list class="pt-0" dense>
        <v-divider light></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="orange">lock</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-dialog max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-list-tile-title v-on="on" style="color:orange">Change Password</v-list-tile-title>
                </template>
                <v-card hover>
                  <v-card-title>
                    <span class="headline">Change {{ Name }} Password</span>
                  </v-card-title>
                  <v-container grid-list-md>
                    <v-layout wrap column>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          type="password"
                          label="Current Password"
                          v-model="password.old"
                          color="orange"
                        ></v-text-field>
                        <v-text-field
                          type="password"
                          label="New Password"
                          v-model="password.new"
                          color="orange"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat @click="chgpw">Change</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="orange">photo_library</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-dialog max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-list-tile-title v-on="on" style="color:orange">Photo Profile</v-list-tile-title>
                </template>
                <v-card hover>
                  <v-card-title>
                    <span class="headline">Pick Preferred Image</span>
                  </v-card-title>
                  <v-container grid-list-md>
                    <v-layout wrap column>
                      <v-flex xs12 sm6 md4>
                        <v-avatar v-for="(p,i) in photos" :key="i">
                          <img :src="p" @click="chgphoto(p)" />
                        </v-avatar>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="orange">feedback</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-dialog persistent v-model="form" max-width="500px">
                <template v-slot:activator="{on}">
                  <v-list-tile-title v-on="on" style="color:orange">Send Feedback</v-list-tile-title>
                </template>
                <v-card hover>
                  <v-card-title>
                    <v-layout justify-center>
                      <span
                        class="headline"
                        style="color:orange"
                      >Describe Your Evaluation About This Web App :)</span>
                    </v-layout>
                  </v-card-title>
                  <v-container>
                    <v-text-field
                      label="Your Name / ID"
                      v-model="feedback.name"
                      clearable
                      color="orange"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field label="Title" v-model="feedback.title" clearable color="orange"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      label="Message"
                      v-model="feedback.message"
                      clearable
                      color="orange"
                    ></v-text-field>
                    <v-layout justify-center align-center align-content-center row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="orange" style="color:white" @click="form = false">Close</v-btn>
                        <v-btn
                          color="orange"
                          style="color:white"
                          @click="sendForm();form = false"
                        >Send</v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon @click="about" color="orange">info</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title @click="about" style="color:orange">About</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-parallax
      :src="require('@/assets/35.jpg')"
      height="100%"
      style="width: 100%; 
    height: 100%; 
    position: relative; "
    >
      <v-container>
        <v-card elevation="24">
          <v-container>
            <v-card v-for="(i,n) in modules" :key="n" color="orange " class="white--text my-3" style="text-align: center" elevation="14">
              <v-container fluid v-if="i.availability">
                <v-layout justify-center align-center align-content-center>
                  <v-img :src="i.img" max-width="50%" max-height="50%"></v-img>
                </v-layout>
                <v-card-text> {{i.desc}}</v-card-text>
                <v-layout justify-center align-center align-content-center column>
                  <!-- <v-btn @click="getJwt"> -->
                    <!-- JWT -->
                  <!-- </v-btn> -->
                  <v-btn
                    depressed
                    round
                    :disabled="!i.LiveVE"
                    @click="VE(n)"
                    :to="'/LiveVE/' + LiveVE.id[n]"
                    style="color:orange"
                   > 🔥 {{ LiveVE.msg[n] }} Virtual Environment </v-btn> 
                  <v-btn
                    depressed
                    round
                    :disabled="!i.pretest"
                    :loading="i.workshop == loading1 ? true : false"
                    @click="testroute(i.workshop,'pretest',1)"
                    style="color:orange"
                  >🔥 Take Pre-Test</v-btn>
                  <v-btn
                    depressed
                    round
                    :disabled="!i.posttest"
                    :loading="i.workshop == loading2 ? true : false"
                    @click="testroute(i.workshop,'posttest',2)"
                    style="color:orange"
                  >🔥 Take Post-Test</v-btn>
                </v-layout>
              </v-container>
            </v-card> 
          </v-container>
        </v-card>
      </v-container>
      
    </v-parallax>
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";

const _auth = firebase.auth();
const _db = firebase.firestore();

export default {
  components: {
  },
  data() {
    return {
      LiveVE: {
        status: [],
        msg: [],
        id: [],
      },
      right: null,
      form: false,
      feedback: {
        name: "",
        title: "",
        message: ""
      },
      modules: "",
      loading2: "",
      loading1: "",
      config: "",
      userPhoto: "",
      photos: [],
      icon: "",
      mini: false,
      password: { new: "", old: "" },
      drawer: null,
      Name: "",
      tmp: {},
      uid: "",
      phtDlg: false
    };
  },
  mounted() {
    this.Name = _auth.currentUser.displayName;
    this.userPhoto = _auth.currentUser.photoURL;
    this.uid = _auth.currentUser.uid;
    
    for (let i = 0; i <= 98; i++) {
      const rand = Math.floor(Math.random() * 999);
      this.photos.push("https://picsum.photos/id/" + rand + "/300/300");
    }

    _db.collection("modules").onSnapshot(e => {
      this.modules = e.docs.map(snapshot => {
        // Add LiveVE ID
        this.LiveVE.id.push(snapshot.data().workshop.toLowerCase())
        this.LiveVE.status.push(false)
        this.LiveVE.msg.push("open")

        return snapshot.data();
      });
    });
  },
  methods: {
  //  getJwt: function(){
  //    _auth.currentUser.getIdToken(true).then(function(token) {
  //      console.log(token)
  //    }).catch(function(err) {
  //      console.log(err)
  //    })
  //  },
    VE: function(n){
      this.LiveVE.status[n] = !this.LiveVE.status[n]
      this.LiveVE.status[n] ? this.LiveVE.msg[n] = "close" : this.LiveVE.msg[n] = "open" 
    },
    //BAD IMPLEMENTATION
    testroute: function(test, type, load) {
      if (load == 1) this.loading1 = test;
      else this.loading2 = test;
      var score;
      _db
        .collection("scores")
        .where("uid", "==", this.uid)
        .get()
        .then(onSnap => {
          score = onSnap.docs.map(firstcheck => {
            return firstcheck.data();
          });
          switch (type) {
            case "pretest":
              if (!score.length) {
                localStorage.setItem("type", type);
                localStorage.setItem("name", test);
                router.push("/exam/start");
              } else router.push("/score");
              break;
            case "posttest":
              if (score[score.length - 1].pretest != undefined) {
                if (score[score.length - 1].posttest == undefined) {
                  localStorage.setItem("type", type);
                  localStorage.setItem("name", test);
                  router.push("/exam/start");
                } else router.push("/score");
              } else router.push("/score");
              break;
            default:
              router.push("/score");
              break;
          }
        })
        .catch(r => {
          this.loading1 = "";
          this.loading2 = "";
          alert(r);
        });
    },
    chgphoto: function(v) {
      this.userPhoto = v;
      _auth.currentUser.updateProfile({ photoURL: v }).catch(er => {
        alert(er);
      });
    },
    sendForm: function() {
      firebase
        .firestore()
        .collection("feedback")
        .add(this.feedback)
        .then(alert("Thank you for your feedback!"))
        .catch(r => {
          alert(r);
        });
    },
    chgname: function() {
      firebase
        .auth()
        .currentUser.updateProfile({ displayName: this.Name })
        .catch(e => alert(e));
    },
    chgpw: function() {
      _auth.currentUser
        .reauthenticateWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            _auth.currentUser.email,
            this.password.old
          )
        )
        .then(
          _auth.currentUser
            .updatePassword(this.password.new)
            .then(e => alert("password updated succesfully ", e))
            .catch(r => alert(r))
        );
    },
    score: function() {
      router.push("/score");
    },
    home: function() {
      router.push("/");
    },
    about: function() {
      router.push("/about");
    },
    files: function() {
      router.push("/files");
    },
    signout: function() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          router.push("/");
        });
    }
  }
};
</script>
